import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { isEmpty, size } from "lodash";
import errorMessages from "../../constant/errorMessages";
import {
  getMemberIndustry,
  getMemberServiceAction,
  getMemberTradeMode,
  getParentServiceAction,
  updateServiceAction,
} from "../../actions/updateProfileAction";
import { connect } from "react-redux";
import InputField from "../InputField";
import "react-toastify/dist/ReactToastify.css";
import CheckBox from "../CheckBox";
import { showSuccessMessage, showErrorMessage } from '../../utils/common';
import regExp from "../../constant/regExpressions";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { getServiceByIndustry } from "../../actions/defaultDataAction";
import ButtonAdminpanel from "../ButtonAdminpanel";
import { useAuth } from "../../AuthProvider";
import { viewProfileAction } from "@/actions/viewProfileAction";

function MemberServices(props) {
  
  const { id } = useParams();
  
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState([]);
  const [errors, setErrors] = useState({});
  const [showInput, setShowInput] = useState(false);
  const [otherServices, setOtherServices] = useState("");
  const [isButtonDisabled, setisButtonDisabled] = useState(false);

  const [isChecked, setIsChecked] = useState(false);
  const [serviceCategories, setServiceCategories] = useState([]);
  const [selectedServiceIds, setSelectedServiceIds] = useState([]);
 // const [companyInfo, setCompanyInfo] = useState(null);
  const { isViewer, isInqUser } = useAuth();

  const [industryId, setIndustryId] = useState(null);
  const [company_trade_mode, setCompanyTradeMode] = useState(null);

  // console.log(isChecked)


  const fetchServices = async (industry_id) => {
    //let industry_id = await props.getMemberIndustry(id);
    // console.log("industry_id ======= ", industry_id);
    await props.getServiceByIndustry(industry_id).then((response) => {
      if (!isEmpty(response)) {
        const options = response.map((service) => ({
          value: service.id,
          label: service.service_name,
        }));
        options.push({ value: "others", label: "Others" });
        setServices(options);
      } else {
        let otherOption = [{ value: "others", label: "Others" }];
        setServices(otherOption);
      }
    }).catch((err) => {
      console.log("Error fetching data:", err);
      showErrorMessage("Something went wrong");
    });
  }

  const fetchParentService = async () => {
    await props.getParentService().then((response) => {
      // console.log('fetchParentService -----> ', response.data.data);
      // setParentServiceList(response.data.data);
      setServiceCategories(response.data.data);
    }).catch((err) => {
      console.log("Error fetching data:", err);
      showErrorMessage("Something went wrong");
    });

  }
  const getParentCheckboxState = (categoryName) => {
    const ids = serviceCategories[categoryName].map((s) => s.id);
    const checkedCount = ids.filter((id) => selectedServiceIds.includes(id)).length;

    if (checkedCount === 0) return "none";
    if (checkedCount === ids.length) return "all";
    return "partial";
  };

  const handleParentCheckboxChange = (e, categoryName) => {
    const serviceIds = serviceCategories[categoryName].map((s) => s.id);
    if (e.target.checked) {
      setSelectedServiceIds((prev) => [...new Set([...prev, ...serviceIds])]);
    } else {
      setSelectedServiceIds((prev) => prev.filter((id) => !serviceIds.includes(id)));
    }
  };

  const handleChildCheckboxChange = (e, service) => {
    const id = service.id;
    if (e.target.checked) {
      setSelectedServiceIds((prev) => [...prev, id]);
    } else {
      setSelectedServiceIds((prev) => prev.filter((sid) => sid !== id));
    }
  };

  const isParentChecked = (categoryName) => {
    const categoryServiceIds = serviceCategories[categoryName].map((s) => s.id);
    return categoryServiceIds.every((id) => selectedServiceIds.includes(id));
  };

  const isChildChecked = (service) => {
    return selectedServiceIds.includes(service.id);
  };

  const fetchMemberService = async () => {
    await props.getMemberService(id).then((response) => {
      if (!isEmpty(response)) {

        if (props.tradeModeType == 'LOG_PTR') {
          const { member_services } = response;

          const serviceIds = member_services
            .filter(res => res.services?.parent_service)
            .map(res => res.service_id);

          setSelectedServiceIds(serviceIds);
        } else {
          const { member_services, other_unapproved_services } = response;

          const mServices = member_services.map((res) =>
            services.find((option) => option.value === res.service_id)
          ).filter(Boolean);

          if (!isEmpty(other_unapproved_services)) {
            setShowInput(true);
            setOtherServices(other_unapproved_services[0].service_name);
            mServices.push({ value: "others", label: "Others" });
          }
          setSelectedService(mServices);
        }

      }
    });
  };

  const handleServiceChange = (value) => {
    setSelectedService((prevSelected) => {
      if (value.value === "others") {
        setShowInput(!showInput);
      }
      if (prevSelected.find((service) => service.value === value.value)) {
        return prevSelected.filter((service) => service.value !== value.value);
      } else {
        return [...prevSelected, value];
      }
    });
  };

  const serviceValidation = () => {
    const errors = {};
    if (props.tradeModeType != 'LOG_PTR') {


      if (isEmpty(selectedService)) {
        errors.serviceError = errorMessages.FIELD_REQUIRED;
      }
      if (selectedService.some((s) => s.value === "others") && isEmpty(otherServices)) {
        errors.otherService = errorMessages.FIELD_REQUIRED;
      }

      setErrors(errors);
      return Object.keys(errors).length > 0;
    }
  };

  const handleServiceSubmit = async (e) => {
    e.preventDefault();
    // const selectedServiceIds = Object.values(selectedServices).flat();
    if (!serviceValidation()) {
      props.showLoading();
      // let industry_id = companyInfo.industry_id;
      // let trade_mode = companyInfo.shipment_mode;

      let ser = props.tradeModeType == 'LOG_PTR' ? selectedServiceIds : selectedService;

      await props
        .updateService(id, ser, otherServices, industryId, company_trade_mode)
        .then((response) => {
          const errors = {};
          if (response === true) {
            showSuccessMessage("Update profile successfully...");
            setTimeout(() => {
              fetchMemberService();
              if (!showInput) {
                setOtherServices("");
              }
            }, 1000);
          } else if (response.message === "Validation Error.") {
            if (!isEmpty(response.errors.ser)) {
              errors.serviceError = response.errors.ser[0];
            }
            if (!isEmpty(response.errors.otherServices)) {
              errors.otherService = response.errors.otherServices[0];
            }
          } else if (response.message === "Provided other service is not approved yet.") {
            errors.otherService = response.message;
          }
          setErrors(errors);
        })
        .catch((error) => {
          console.log(error);
          showErrorMessage("Something went wrong");
        });

      props.hideLoading();
    }
  };


  const handleFocusOut = async (e) => {
    let flag = 0;
    let er = { ...errors };
    if (e.target.name === 'other_service') {
      if (e.target.value === '') {
        flag = 1;
        er.otherService = errorMessages.FIELD_REQUIRED;
      } else {
        const serviceregExp = regExp.designation;
        const check = serviceregExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.otherService = errorMessages.IN_VALID_FIELD_FORMAT;
        }
        else {
          flag = 0;
          er.otherService = '';
        }
      }
    }
    setErrors(er);
    if (flag === 0) {
      setisButtonDisabled(false);
      return false;
    } else {
      setisButtonDisabled(true);
      return true;
    }

  }

  // const fetchCompanyInfo = async (member_id) => {
  //   console.log("fetchCompanyInfo is called >>>>>>>>>>")
  //   await props.viewCompany(member_id).then(async (response) => {
  //     console.log("response >>>>>>>>>>", response);
  //     if (response.status) {
  //       if (!isEmpty(response.data)) {
  //         setCompanyInfo(response.data[0]);
  //         let trade_mode = response.data[0].shipment_mode;
  //         if (trade_mode === "Logistic Partner") {
  //           fetchParentService();
  //         } else {
  //           fetchServices();
  //         }

  //       }
  //     }
  //   });
  // }

  useEffect(() => {
    if (!showInput) {
      let errObj = { ...errors };

      if (isEmpty(otherServices)) {
        if (errObj.otherService !== undefined) {
          errObj.otherService = "";
          setisButtonDisabled(false);
        }
      } else if (!isEmpty(otherServices)) {
        setOtherServices("");
        if (errObj.otherService !== undefined) {
          errObj.otherService = "";
          setisButtonDisabled(false);
        }
      }
      setErrors(errObj);

    }
  }, [showInput]);

  useEffect(() => {
    if (size(services) > 0 || size(serviceCategories) > 0) {
      fetchMemberService();
    }
  }, [services, serviceCategories]);

  /* useEffect(() => {
    fetchServices();
  }, [props.company_info]); */

  useEffect(() => {
    //fetchParentService();
    if(props.cpInfo) {
      setIndustryId(props.cpInfo.industry_id);
      setCompanyTradeMode(props.cpInfo.shipment_mode);

      if(props.cpInfo.shipment_mode == "Logistic Partner") {
        fetchParentService();
      } else {
        let industry_id = props.cpInfo.industry_id;
        fetchServices(industry_id);
      }
    }
  }, [props.cpInfo]);

  // useEffect(() => {
  //   fetchCompanyInfo(id);
  // }, [id]);



  const isAnyChildChecked = (categoryName) => {
    return serviceCategories[categoryName].some((s) =>
      selectedServiceIds.includes(s.id)
    );
  };

  const styleError = {
    display: "block",
  };

  return (
    <div>
      <h3 className='company-info-text'>Services</h3>
      <div className="p-4 pb-4 card-shadow bg-white rounded">
        <form onSubmit={handleServiceSubmit}>
          <div className=" fv-plugins-icon-container">
            <div>
              <div className='d-flex justify-content-between align-items-center border-bottom pb-2'>
                <h4 className='head-office-text'>Company Services</h4>
              </div>

              {props.tradeModeType != 'LOG_PTR' &&
                <div className="servies-main-section">
                  {services.map((ser, k) => {
                    // console.log("checkbox========>", k)
                    return (

                      <div className="services-child" key={`service_${k}`}>
                        <div>
                          <CheckBox
                            key={`chk_${k}`}
                            value={ser.value}
                            onChange={() => handleServiceChange(ser)}
                            checked={(ser.value !== "others" && selectedService.some((service) => service.value === ser.value)) || (ser.value === "others" && showInput)}
                            disabled={props.disableProfile || isViewer || isInqUser}
                            id={k}
                          ></CheckBox>
                        </div>

                        <label className="mx-1" for={k} key={`service_name_${k}`}>{ser.label}</label>

                      </div>

                    );
                  })}
                </div>
              }

              {props.tradeModeType == 'LOG_PTR' &&
                <div className="servies-main-section">
                  {Object.entries(serviceCategories).map(([categoryName, services], i) => (
                    <div className="services-child">
                      <label className="mx-1 w-100" key={categoryName}>
                        <div className="accordion" id={`accordionExample-${i}`}>
                          <div className="accordion-item">
                            <h2 className="accordion-header" id={`heading-${i}`}>
                              <button
                                className={`accordion-button ${isAnyChildChecked(categoryName) ? "" : "collapsed"}`}
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse-${i}`}
                                aria-expanded={isAnyChildChecked(categoryName)}
                                aria-controls={`collapse-${i}`}
                                disabled={props.disableProfile || isViewer || isInqUser}
                              >
                                <label className="me-2 checkbox-container">
                                  <CheckBox
                                    className="custom-input"
                                    onChange={(e) => handleParentCheckboxChange(e, categoryName)}
                                    checked={isParentChecked(categoryName)}
                                    disabled={props.disableProfile || isViewer || isInqUser}
                                  />
                                  <span className={`custom-checkbox ${getParentCheckboxState(categoryName)}`}></span>
                                </label>
                                {categoryName}
                              </button>
                            </h2>
                            <div
                              id={`collapse-${i}`}
                              className={`accordion-collapse collapse ${isAnyChildChecked(categoryName) ? "show" : ""}`}
                              data-bs-parent={`#accordionExample-${i}`}
                            >
                              <div className="accordion-body">
                                <div className="child-serives-multi">
                                  {services.map((service, j) => (
                                    <div className="mt-2" key={service.id}>
                                      <div>
                                        <CheckBox
                                          className="me-2 mt-1"
                                          onChange={(e) => handleChildCheckboxChange(e, service)}
                                          checked={isChildChecked(service)}
                                          disabled={props.disableProfile || isViewer || isInqUser}
                                        />
                                      </div>
                                      <p>{service.service_name}</p>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </label>
                    </div>
                  ))}

                </div>
              }


              {errors.serviceError && (
                <div className="invalid-feedback" style={styleError}>
                  {errors.serviceError}
                </div>
              )}
            </div>
          </div>

          {showInput && props.tradeModeType != "LOG_PTR" && (
            <div className="my-4 w-25 pb-4">
              <label className="other-service-lable required">Other Service<span class="text-danger"> *</span></label>
              {
                <InputField
                  placeholder={"Enter service name"}
                  value={otherServices}
                  onChange={(e) => setOtherServices(e.target.value)}
                  className={"input-error-border my-1"}
                  onBlur={handleFocusOut}
                  name="other_service"
                  disabled={props.disableProfile || isViewer || isInqUser}
                  autoComplete="off"

                />
              }
              {errors.otherService && (
                <div className="invalid-feedback" style={styleError}>
                  {errors.otherService}
                </div>
              )}

              {errors.disapprovedService && (
                <div className="invalid-feedback" style={styleError}>
                  {errors.disapprovedService}
                </div>
              )}
              {errors.uniqueOtherService && (
                <div className="invalid-feedback" style={styleError}>
                  {errors.uniqueOtherService}
                </div>
              )}
            </div>
          )}
          {(!props.disableProfile && !isViewer && !isInqUser) && (
            <div className="profile-btn mt-3 border-top">
              {/* <Button className='back-home mx-3 mt-3' type="button">Cancel</Button> */}

              <ButtonAdminpanel
                type="submit"
                className="mt-4 btn-regi"
                disabled={isButtonDisabled || props.disableProfile || isViewer || isInqUser}
              >
                Save Changes
              </ButtonAdminpanel>
            </div>
          )}
        </form>
        {/* <ToastContainer /> */}
      </div >
    </div >
  );
}
const mapStateToProps = (state) => {
  return {
    updateService: state.update.updateService,
    getMemberService: state.update.getMemberService,
    company_info: state.update.updateProfile,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateService: (member_id, service, otherServices, industry_id, trade_mode) =>
      dispatch(updateServiceAction(member_id, service, otherServices, industry_id, trade_mode)),
    getMemberService: (member_id) =>
      dispatch(getMemberServiceAction(member_id)),
    getParentService: () => dispatch(getParentServiceAction()),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    getServiceByIndustry: (industry_id) => dispatch(getServiceByIndustry(industry_id)),
    getMemberIndustry: (member_id) => dispatch(getMemberIndustry(member_id)),
    getMemberTradeMode: (member_id) => dispatch(getMemberTradeMode(member_id)),
    viewCompany: (member_id) => dispatch(viewProfileAction(member_id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MemberServices);
